module.exports = __webpack_public_path__ + "img/bg-service-4.35dc453b.svg";